export default 'brand';
